import { Index } from "./lib";
export default Index
